import { TableColumn } from "react-data-table-component";
import { Link } from "react-router-dom";
import { LI, UL } from "../../AbstractElements";
import {
  CompanyRoleTableActionTypes,
  FormAccess,
  UserRowType,
} from "../../Types/UserManagement";
import { UserManagementRoute } from "../../utils/Constant";

export const UserColumnStructure: TableColumn<UserRowType>[] = [
  {
    name: "Name",
    selector: (row) => `${row.firstName} ${row.lastName}`,
    sortable: true,
    center: false,
  },
  {
    name: "Email",
    selector: (row) => row.email,
    sortable: true,
    center: true,
  },
  {
    name: "Mobile",
    selector: (row) => row.contactNumber,
    sortable: true,
    center: true,
  },
  {
    name: "Action",
    cell: (row) => (
      <TableActions
        id={row.id}
        setCentered={row.setCentered}
        modalDetails={row.modalDetails}
      />
    ),
    sortable: true,
    center: true,
  },
];

const TableActions: React.FC<CompanyRoleTableActionTypes> = ({
  id,
  setCentered,
  modalDetails,
}) => {
  const handleDeleteClick = () => {
    setCentered && setCentered(true);
    modalDetails &&
      modalDetails({
        id,
        type: FormAccess.DELETE,
      });
  };

  return (
    <UL className="action simple-list flex-row" id={id}>
      <LI className="view" aria-disabled>
        <Link to={`/${UserManagementRoute}/${id}`}>
          <i className="icon-eye" />
        </Link>
      </LI>
      <LI className="delete" aria-disabled onClick={handleDeleteClick}>
        <Link to={""}>
          <i className="icon-trash" />
        </Link>
      </LI>
    </UL>
  );
};
